import { baseUrl } from '@/config'
import request from '@/axios'

// 列表
export function rolefetchList(query) {
  return request({
    url: baseUrl+'/system/role/listdata',
    method: 'post',
    data: query
  })
}

// 保存
export function rolesave(query) {
  console.log('query', query)
  return request({
    url: baseUrl+'/system/role/save',
    method: 'post',
    params: query
  })
}

// 角色下菜单权限列表
export function roleMenuList(data) {
  return request({
    url: baseUrl+'/system/role/rolemenus',
    method: 'post',
    params:data
  })
}

export function rolemenusave(data) {
  return request({
    url: baseUrl+'/system/role/rolemenussave',
    method: 'post',
    params: data
  })
}

export function addObj(obj) {
  return request({
    url: baseUrl+'/system/role/',
    method: 'post',
    data: obj
  })
}

export function putObj(obj) {
  return request({
    url: baseUrl+'/admin/role',
    method: 'put',
    data: obj
  })
}

export function delObj(id) {
  return request({
    url: baseUrl+'/system/role/' + id,
    method: 'delete'
  })
}

export function permissionUpd(roleId, menuIds) {
  return request({
    url: baseUrl+'/admin/role/menu',
    method: 'put',
    data: {
      roleId: roleId,
      menuIds: menuIds
    }
  })
}

export function fetchRoleTree(roleName) {
  return request({
    url: baseUrl+'/admin/menu/tree/' + roleName,
    method: 'get'
  })
}
